/*
 * menu-gallery.js
 * ------------------------------------------------------------
 * Wires up Fancybox v4 lightbox over the menu-board collection-list items.
 * Loaded only on menu-board pages (see layout/theme.liquid).
 *
 * Originally an inline <script> in theme.liquid that loaded jQuery 3.6 from
 * cdnjs on every page just to power this one feature. Refactored 2026-05-26:
 *   - Removed jQuery dependency (Fancybox v4 is vanilla JS).
 *   - Moved to its own asset, conditionally loaded only on menu pages.
 *   - Saves ~90KB + a third-party request on every non-menu page.
 * ------------------------------------------------------------
 */
(function () {
  function init() {
    var menuItems = document.querySelectorAll('.collection-list__item--media');
    if (!menuItems.length) {
      return;
    }

    menuItems.forEach(function (item) {
      var mediaElement = item.querySelector('.collection-list__media');
      var imgElement = mediaElement ? mediaElement.querySelector('img') : null;
      if (!imgElement) {
        return;
      }

      var imgSrc = imgElement.src;
      var isSvg = imgSrc.toLowerCase().endsWith('.svg') || imgSrc.toLowerCase().includes('.svg?');

      var highResUrl;
      if (isSvg) {
        highResUrl = imgSrc;
      } else {
        var baseUrl = imgSrc.split('?')[0];
        baseUrl = baseUrl.replace(/_\d+x\d+/, '');
        highResUrl = baseUrl + '?width=2000&height=2000&crop=false';
      }

      var galleryTrigger = document.createElement('a');
      galleryTrigger.href = highResUrl;
      galleryTrigger.dataset.fancybox = 'menu-gallery';
      galleryTrigger.dataset.caption = imgElement.alt || 'Menu Image';
      galleryTrigger.style.cssText =
        'position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;cursor:pointer;';

      item.style.position = 'relative';
      item.appendChild(galleryTrigger);
    });

    if (typeof Fancybox !== 'undefined') {
      Fancybox.bind('[data-fancybox]', {
        Images: { zoom: true },
        Toolbar: {
          display: ['zoom', 'slideshow', 'fullscreen', 'close'],
        },
      });
    }
  }

  // Run after Fancybox loads. Slight delay matches the original behavior, which
  // waited 1s before scanning the DOM (because the collection list was
  // hydrating asynchronously).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 1000);
    });
  } else {
    setTimeout(init, 1000);
  }
})();
